// TODO: Use environment variables with firebase hosting
const Production: IConfig = {
    Environment: "production",
    StripeUrl: "https://dhs-payment-892b3cdec73f.herokuapp.com",
    MessagesUrl: "https://dhs-backend-7eeabce30221.herokuapp.com/api/v1",
    StripePublishableKey: "pk_live_ydmLXp2GB54LeZHh3TQ4Zwt1",
    PaymentSuccessfulReturnUrl: "https://payment.thedefinedcrm.com",
    AdsApiUrl: "https://dhs-backend-7eeabce30221.herokuapp.com/api/v1",
    ApiBaseUrl: "https://dhs-backend-7eeabce30221.herokuapp.com/api/v1",
    PhoneNumbers: {
        Main: "(702) 747-0901",
        MainRaw: "7027470901",
        Twilio: "+17028205488",
        TwilioRaw: "17028205488",
        Notification: "7023722579",
        Additional: "7028834839"
    }
}

const Debug:IConfig = {
    Environment: "debug",
    StripeUrl: "https://localhost:3456",
    MessagesUrl: "http://localhost:4000/api/v1",
    StripePublishableKey: "pk_test_tu1losGXCQrudFqfygxKxSYn",
    PaymentSuccessfulReturnUrl: "http://localhost:3001",
    AdsApiUrl: "http://localhost:4000/api/v1",
    ApiBaseUrl: "http://localhost:4000/api/v1",
    PhoneNumbers: {
        Main: "(702) 747-0901",
        MainRaw: "7027470901",
        Twilio: "+17028205488",
        TwilioRaw: "17028205488",
        Notification: "7023722579",
        Additional: "7028834839"
    }
}

const Staging:IConfig = {
    Environment: "staging",
    StripeUrl: "https://dhs-payment-staging-2ddb584cd030.herokuapp.com",
    MessagesUrl: "https://dhs-backend-staging-e48fcd0503b0.herokuapp.com/api/v1",
    StripePublishableKey: "pk_live_ydmLXp2GB54LeZHh3TQ4Zwt1",
    PaymentSuccessfulReturnUrl: "https://payment.thedefinedcrm.com",
    AdsApiUrl: "https://dhs-backend-staging-e48fcd0503b0.herokuapp.com/api/v1",
    ApiBaseUrl: "https://dhs-backend-staging-e48fcd0503b0.herokuapp.com/api/v1",
    PhoneNumbers: {
        Main: "(702) 747-0901",
        MainRaw: "7027470901",
        Twilio: "+17028205488",
        TwilioRaw: "17028205488",
        Notification: "7023722579",
        Additional: "7028834839"
    }
}

type IConfig = {
    Environment: string,
    StripeUrl: string,
    MessagesUrl: string,
    StripePublishableKey: string,
    PaymentSuccessfulReturnUrl: string,
    AdsApiUrl: string,
    ApiBaseUrl: string,
    PhoneNumbers: {
        Main: string,
        MainRaw: string,
        Twilio: string,
        TwilioRaw: string,
        Notification: string,
        Additional: string
    }
}

const getEnvironmentConfig = (): IConfig => {
    const env = process.env.REACT_APP_ENVIRONMENT || "debug";
    switch (env) {
        case "production":
            return Production;
        case "staging":
            return Staging;
        default:
            return Debug;
    }
}

export const Config = {
    Env: getEnvironmentConfig(),
    isDevelopment: () => {
        return Config.Env.Environment === "debug";
    },
    isStaging: () => {
        return Config.Env.Environment === "staging";
    },
    isProduction: () => {
        return Config.Env.Environment === "production";
    }
}
